import Instance from "./instance";

export const GetDisclaimerText = async () => {
  return await Instance.instance.get("content/disclaimer");
};